<template>
  <div class="select">
    <transition :name="isReverse ? 'reverse-slide' : 'slide'">
      <sort-select-question v-show="step === 0" :number="0" :data="questions[0]" :selectedType="status.skin" @clickedAnswer="selectedChoice" />
    </transition>
    <transition :name="isReverse ? 'reverse-slide' : 'slide'">
      <sort-select-question v-show="step === 1" :number="1" :data="questions[1]" @clickedMultiAnswer="selectedMultiChoice" @clickedNext="next" />
    </transition>
    <transition :name="isReverse ? 'reverse-slide' : 'slide'">
      <sort-select-question v-show="step === 2" :number="2" :data="questions[2]" :selectedType="status.make" @clickedAnswer="selectedChoice" />
    </transition>
    <transition :name="isReverse ? 'reverse-slide' : 'slide'">
      <sort-select-question v-show="step === 3" :number="3" :data="questions[3]" :selectedType="status.age" @clickedAnswer="selectedChoice" />
    </transition>
    <sort-select-number :number="step" />
    <sort-select-step :number="step" @clickedNumber="toStep" />
    <part-back @clickedButton="toBack" />
  </div>
</template>

<script>
import { SKIN_TYPE, WORRIES, MAKE_FREQUENCY, AGE } from '@/config/sortConditions.js';

import PartBack from './PartBack.vue';
import SortSelectNumber from './SortSelectNumber.vue';
import SortSelectQuestion from './SortSelectQuestion.vue';
import SortSelectStep from './SortSelectStep.vue';

export default {
  components: { PartBack, SortSelectNumber, SortSelectStep, SortSelectQuestion },
  name: 'PageSortSelect',
  data: () => {
    return {
      step: 0,
      status: {
        skin: null,
        worriesome: [],
        make: null,
        age: null
      },
      isReverse: false,
      questions: [
        {
          type: 'skin',
          title_view: false,
          choices_view: false,
          multi_type: false,
          title: 'あなたの肌の状態を教えてください。',
          choices: SKIN_TYPE
        },
        {
          type: 'worriesome',
          title_view: false,
          choices_view: false,
          multi_type: true,
          title: '肌のお悩みについて気になることを複数教えてください。',
          choices: WORRIES
        },
        {
          type: 'make',
          title_view: false,
          choices_view: false,
          multi_type: false,
          title: 'メーキャップ頻度を教えてください',
          choices: MAKE_FREQUENCY
        },
        {
          type: 'age',
          title_view: false,
          choices_view: false,
          multi_type: false,
          title: '年代を教えてください。',
          choices: AGE
        }
      ]
    };
  },
  methods: {
    /**
     * 戻るボタンを押した時
     */
    toBack() {
      this.isReverse = true;
      this.step === 0 ? this.$emit('clickedBack') : this.step--;
    },
    /**
     * 選択肢を選んだ時
     * @param type {String} 選択された設問の種類
     * @param choice {String} 選択された解答のID
     */
    selectedChoice(type, choice, index) {

      console.log("-------selected choice---------");
      console.log(type, choice);

      this.status[type] = choice;
      // selectedを更新する

      // this.questions[this.step].choices[index].selected = true;
      this.$set(this.questions[this.step].choices[index], 'selected', true);

      setTimeout(() => this.next(), 100);
    },
    /**
     * マルチタイプ選択肢を選んだ時
     * @param choice {String} 選択された解答のID
     * @param index {Number} 選択された解答のindex
     */
    selectedMultiChoice(choice, index) {
      console.log("-------selected Multi choice---------");
      console.log(choice, index);


      if (this.status.worriesome.includes(choice)) {
        this.status.worriesome = this.status.worriesome.filter(item => item !== choice);
        // this.questions[this.step].choices[index].selected = false;
        this.$set(this.questions[this.step].choices[index], 'selected', false);

      } else {
        this.status.worriesome.push(choice);
        // this.questions[this.step].choices[index].selected = true;
        this.$set(this.questions[this.step].choices[index], 'selected', true);
      }
    },
    /**
     * 次へ進む
     */
    next() {
      this.isReverse = false;
      if (this.step === 3) {
        const _statusKeys = Object.values(this.status);
        const _completeCheckIndex = _statusKeys.findIndex(item => item === null);
        if (_completeCheckIndex === -1) {
          this.$emit('selectedChoices', this.status);
        } else {
          this.step = _completeCheckIndex;
          this.isReverse = true;
          this.stepShow(this.step);
        }
      } else {
        this.step++;
        this.stepShow(this.step);
      }
    },
    /**
     * 最初から
     */
    sortFirst() {
      this.step = 0;

      // console.log("-------sort first---------");


      this.$set(this.status, 'skin', null);
      this.$set(this.status, 'worriesome', []);
      this.$set(this.status, 'make', null);
      this.$set(this.status, 'age', null);

      const stepTotal = 4;
      for(let stepIndex=0;stepIndex<stepTotal;stepIndex++){
        const choicesTotal = this.questions[stepIndex].choices.length;
        for(let i=0;i<choicesTotal;i++){
          // console.log(`Update: stepIndex:${stepIndex} i:${i}`);
          // console.log(this.questions[stepIndex].choices[i]);
          this.$set(this.questions[stepIndex].choices[i], 'selected', false);
        }
      }
      // console.log(this.questions);


      for (let _index = 0; _index < this.questions.length; _index++) {
        this.$set(this.questions[_index], 'title_view', false);
        this.$set(this.questions[_index], 'choices_view', false);
      }
    },
    /**
     * stepが選ばれた時
     * @param number {Number} 選ばれた番号
     */
    toStep(number) {
      if (this.step > number) {
        this.step = number;
        this.isReverse = true;
        this.stepShow(this.step);
      } else {
        this.step = number;
        this.isReverse = false;
        this.stepShow(this.step);
      }
    },
    /**
     * 各ステップのロードアニメーションを開始する
     * @param number {Number} 該当のステップの番号
     */
    stepShow(number) {
      const _time = 170 + this.questions[number].title.length * 60;
      this.questions[number].title_view = true;
      setTimeout(() => {
        this.questions[number].choices_view = true;
      }, _time);
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
